import React, { useState, useEffect } from "react";
import { message, Form, Input, Button, Card, Typography, Row, Col } from "antd";
import httpUtil from "../../utils/httpUtil";

const { Title } = Typography;

export const PersonalInformation = ({ userInfo }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [editable, setEditable] = useState(false);
  const [initialData, setInitialData] = useState(null);

  const fetchUserData = async () => {
    try {
      setLoading(true);
      setInitialData(userInfo);
      form.setFieldsValue(userInfo);
    } catch (error) {
      message.error("获取用户信息失败");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, [form]);

  const toggleEdit = () => {
    if (editable) {
      form.submit();
    } else {
      setEditable(true);
    }
  };

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const params = {
        user_id: userInfo.user_id,
        newPassword: values.new_password,
        contact: values.contact,
      };
      
      httpUtil.updateUserInfo(params).then((res) => {
        if (res.success) {
          message.success("个人信息修改成功");
          form.setFieldsValue({
            new_password: "",
          });
          const updatedUserInfo = {
            ...userInfo,
            contact: values.contact,
          };
          localStorage.setItem("userInfo", JSON.stringify(updatedUserInfo));
          setInitialData(updatedUserInfo);
          setEditable(false);
        }
      });
    } catch (error) {
      message.error("更新失败");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 1000, margin: "0 auto", padding: "24px" }}>
      <Card
        title={
          <Title level={4} style={{ margin: 0 }}>
            个人信息
          </Title>
        }
        bordered={false}
        headStyle={{ borderBottom: "1px solid #f0f0f0" }}
        bodyStyle={{ padding: "24px" }}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          initialValues={initialData}
        >
          <Row gutter={24}>
            {/* 第一列 */}
            <Col span={12}>
              <Form.Item label="用户ID" name="user_id">
                <Input disabled style={{ background: "#fafafa" }} />
              </Form.Item>

              <Form.Item label="用户名" name="username">
                <Input disabled style={{ background: "#fafafa" }} />
              </Form.Item>

              <Form.Item
                label="密码"
                name="new_password"
                rules={[{ required: editable, message: "请输入您的新密码" }]}
              >
                <Input.Password 
                  placeholder={editable ? "输入新密码" : "********"} 
                  disabled={!editable}
                />
              </Form.Item>
            </Col>

            {/* 第二列 */}
            <Col span={12}>
              <Form.Item label="角色" name="role">
                <Input disabled style={{ background: "#fafafa" }} />
              </Form.Item>

              <Form.Item label="姓名" name="full_name">
                <Input disabled style={{ background: "#fafafa" }} />
              </Form.Item>

              <Form.Item
                label="联系电话"
                name="contact"
                rules={[
                  { 
                    pattern: /^1[3-9]\d{9}$/, 
                    message: "请输入有效的手机号码",
                    required: editable 
                  },
                ]}
              >
                <Input disabled={!editable} />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item style={{ marginTop: "32px", textAlign: "center" }}>
            <Button 
              type="primary" 
              onClick={toggleEdit}
              loading={loading}
              style={{ width: "120px", height: "40px" }}
            >
              {editable ? "保存修改" : "修改信息"}
            </Button>
            
            {editable && (
              <Button 
                style={{ marginLeft: "16px", width: "120px", height: "40px" }}
                onClick={() => {
                  form.resetFields();
                  setEditable(false);
                }}
              >
                取消
              </Button>
            )}
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};